import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Shield } from 'lucide-react'
import { type KBSettings } from '@/hooks/useSettings'

interface PrivacySettingsCardProps {
  formData: KBSettings
  handleChange: (field: keyof KBSettings, value: any) => void
}

export function PrivacySettingsCard({ formData, handleChange }: PrivacySettingsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Shield className="h-5 w-5 text-primary" />
          Privacy Settings
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <Label htmlFor="permission">Access Permission</Label>
          <Select
            value={formData.permission}
            onValueChange={(value) => handleChange('permission', value)}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="me">Private - Only me</SelectItem>
              <SelectItem value="team">Team - Share with team</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-xs text-muted-foreground">
            Who can access this knowledge base
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
